export default {
  "b2b.zdroje-grid-columns.typ.name.label": "Name",
  "b2b.zdroje-grid-columns.typ.vyznam.label": "Meaning",
  "b2b.zdroje-grid-columns.typ.popis.label": "Description"
};
